import axios from "axios";

export const uploadFile = (fileData: any) => {
  return axios.post(
    `/api/method/ace_be_app.api.item.upload`,
    fileData
  );
};
